import content from './content/privacy-policy.json';

export const privacyPolicyMock = {
  name: 'privacy-policy',
  layoutType: 1,
  areasList: [
    {
      id: 'privacy-policy-main',
      componentName: 'Comp:PrivacyPolicyPage',
      content: JSON.stringify(content)
    }
  ]
};
